// extracted by mini-css-extract-plugin
var _1 = "header-icon__YqAOX";
export { _1 as "headerIcon" }
